import { lazyWithRetry } from "utils/helpers/lazyWithRetry";

const VerifyEmailPage = lazyWithRetry(() =>
  import("pages/AuthPages/VerifyEmailPage")
);

const AuthZeroLoginPage = lazyWithRetry(() =>
  import("pages/AuthPages/AuthZeroLoginPage")
);

export { AuthZeroLoginPage, VerifyEmailPage };
